export interface IPedidoResponse {
    id_pedido: number,
    id_transacao: string,
    activate_signature: boolean
}

type PedidoResponse = IPedidoResponse | number | string

export const instanceOfIPedidoResponse = (object: any): object is IPedidoResponse => {
    return 'id_pedido' in object &&
        'id_transacao' in object &&
        'activate_signature' in object
}

export const instanceOfPedidoResponse = (object: any): object is PedidoResponse => {
    return typeof object === 'number' ||
        typeof object === 'string' ||
        typeof object === 'boolean' ||
        instanceOfIPedidoResponse(object)
}

export default PedidoResponse